import { axios } from '@/utils/request';

export function getAppointApiConfig(parameter) {
  return axios({
    url:
      process.env.VUE_APP_CMS_SYSTEM + '/sys/sysBcConfig/getAppointApiConfig',
    params: parameter,
    method: 'get',
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

export function editApiConfig(parameter) {
  return axios({
    url: process.env.VUE_APP_CMS_SYSTEM + '/sys/sysBcConfig/edit',
    method: 'post',
    data: parameter,
  });
}
